import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { get } from "src/services/http-service";
import DenseList from 'src/components/DenseList';
import SblDialog from 'src/components/SblDialog';


function FormsPage() {

  const [entries, setEntries] = useState([]);
  const [sblId, setSblId] = useState(-1);
  const [previewTitle, setPreviewTitle] = useState('');

  document.title = 'Blanketter | Infosoc';

  const load = async () => {
    const response = await get('/forms');
    setEntries(response.entries);
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }} mt={10} ml={2}>
      <DenseList entries={entries} offsetTop={120} showFilter={true} onSelect={(index, entry) => setSblId(entry.id)} />
      <SblDialog open={sblId !== -1} onClose={() => setSblId(-1)} id={sblId} />
    </Box>
  );
}


export default FormsPage;